const pattern = new RegExp([
  '(http|ftp|https):\\/\\/[\\w\\-_]+(\\.[\\w\\-_]+)',
  '+([\\w\\-\\.,@?^=%&amp;:/~\\+#]*[\\w\\-\\@?^=%&amp;/~\\+#])',
].join(''), 'g');

export const withLinks = (value: string) => {
  return value.replace(pattern, '<a class=\"replaced-link\" target="_blank" href=\"$&\">External link</a>');
};

export const enableTooltip = (value: string) => {
  return value.match(pattern);
};
